import type { Rechtstext } from '@dxl/shared';
import { Button, Dialog } from '@dxl/ui';

/**
 * Rechtstext als Lightbox. Das HTML kommt mit eigenen Stilen vom Server und läuft in einem
 * abgeschotteten iframe (ohne Skripte, ohne Zugriff auf die Seite).
 */
export function RechtstextDialog({
  text,
  onSchliessen,
  aktion,
}: {
  text: Pick<Rechtstext, 'titel' | 'html' | 'version' | 'stand'> | null;
  onSchliessen: () => void;
  aktion?: { titel: string; onKlick: () => void; laedt?: boolean };
}) {
  return (
    <Dialog
      gross
      breite={900}
      offen={!!text}
      titel={text ? `${text.titel} · Version ${text.version}, Stand ${text.stand}` : ''}
      onSchliessen={onSchliessen}
      fuss={
        <div className="knopfreihe knopfreihe--rechts">
          <Button art="sekundaer" onClick={onSchliessen}>Schließen</Button>
          {aktion && <Button laedt={aktion.laedt} onClick={aktion.onKlick}>{aktion.titel}</Button>}
        </div>
      }
    >
      {text && <iframe className="rechtstext" title={text.titel} sandbox="" srcDoc={`<!doctype html><meta charset="utf-8"><body style="margin:0;font-family:system-ui,sans-serif">${text.html}</body>`} />}
    </Dialog>
  );
}
